import CookieConsent from 'react-cookie-consent';
import React, { useEffect } from 'react';
import { FONTS, FONT_WEIGHT } from '../common/theme';
// import { RequestID } from '../common/enums';
// import { fetchData } from '../common/api/actions';
import { getText } from '../common/utils/helpers';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';

const COOKIES_PAGE_URL =
  'https://emuzejs.lnvm.lv/info/par-emuzejs-lnvm-lv/datu-drosiba-un-privatums';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      cookieContent: {
        fontFamily: FONTS.alegreya,
        fontWeight: FONT_WEIGHT.medium,
        color: 'lightGray',
        fontSize: '14px',
        lineHeight: '16px',
        '& a:link': {
          color: 'lightGray',
        },
        '& a:visited': {
          color: 'gray',
        },
        '& a:hover': {
          color: 'white',
        },
      },
      cookieButton: {
        textTransform: 'uppercase',
      },
    })
);

const cookiesMessage = `Šī tīmekļa vietne izmanto sīkdatnes, lai nodrošinātu tīmekļa vietnes optimālu darbību. Nospiežot pogu “Piekrītu” Jūs atļaujat to izmantošanu. Savu piekrišanu Jūs jebkurā laikā varat atsaukt, nodzēšot saglabātās sīkdatnes.`;

const cookiesAccept = 'Piekrītu';

const linkText = 'Uzzini vairāk šeit!';

const Cookies = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <CookieConsent
      location="bottom"
      buttonText={cookiesAccept}
      cookieName="emuzejs.lnvm.lv/stasti"
      contentClasses={classes.cookieContent}
      buttonClasses={classes.cookieButton}
    >
      {cookiesMessage}{' '}
      <a href={COOKIES_PAGE_URL} target="_self">
        {linkText}
      </a>
    </CookieConsent>
  );
};

export default Cookies;
